// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3OJvy","left":"StickyBox_left__aWEs6","right":"StickyBox_right__3CycN"};